import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DataTransferProgressService } from '@app/data-transfer/services/data-transfer-progress.service';
import { Animations, DefaultAnimationParams } from '@app/shared/animations/animations';
import { AppIconComponent } from '@app/shared/app-icon/app-icon.component';
import { ProgressSpinnerDiameterDirective } from '@app/shared/directives/progress-spinner-diameter.directive';
import { RouteConstants } from '@app/shared/models/route-constants';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
	selector: 'data-transfer-indicator',
	imports: [
		ProgressSpinnerModule,
		ProgressSpinnerDiameterDirective,
		AppIconComponent,
		CommonModule,
		RouterModule
	],
	templateUrl: './data-transfer-indicator.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [Animations.slideInUpDown]
})
export class DataTransferIndicatorComponent {

	activeTransfers$ = this.progress.activeTransfers$;
	animationParams = DefaultAnimationParams;
	routerLink = RouteConstants.DataTransfer;

	constructor (
		private readonly progress: DataTransferProgressService
	) {}
}
